import React from 'react'

interface StepConfig {
  // A component to render for this step
  component: React.ComponentType<any>
  // Optional: step name or label
  label?: string
  // Optional: any other metadata needed
  [key: string]: any
}

interface StepComponentProps {
  step: number
  values: any
  errors: any
  touched: any
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void
  onBlur: (e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => void
  onTeamNameError?: (err: string | null) => void
  setWidgetConfigErrors?: (errors: any) => void
  editMode?: boolean
  onboardingDashboard?: any
  productId?: string
  setProductId?: (id: string) => void
  dispatch?: any
  setStep?: (step: number) => void
  onProductIdChange?: (id: string, label: string, isSameProduct: boolean) => void
  // New: stepConfig allows dynamic step rendering
  stepConfig?: StepConfig[]
  handleDropdownChange?: (option: any) => void
  onClose?: () => void
  onToastFinish?: () => void
  // AppD Account management (like Angular's this.selectedAppDAccount)
  selectedAppDAccount?: any
  setSelectedAppDAccount?: (account: any) => void
}

/**
 * StepComponent renders the onboarding stepper using a configurable stepConfig array.
 * If stepConfig is provided, it renders the corresponding component for the current step.
 * If not, it falls back to legacy switch-based logic (for backward compatibility).
 */
const StepComponent: React.FC<StepComponentProps> = props => {
  const {
    step,
    values,
    errors,
    touched,
    onChange,
    onBlur,
    onTeamNameError,
    setWidgetConfigErrors,
    editMode,
    onboardingDashboard,
    productId,
    setProductId,
    dispatch,
    setStep,
    stepConfig,
    onToastFinish,
  } = props
  React.useEffect(() => {
    if (stepConfig && Array.isArray(stepConfig) && step >= stepConfig.length) {
      if (typeof onToastFinish === 'function') {
        onToastFinish()
      }
    }
  }, [step, stepConfig, props])

  // If stepConfig is provided, render the step from config
  if (stepConfig && Array.isArray(stepConfig)) {
    if (stepConfig[step]) {
      const stepEntry = stepConfig[step]
      const Step = stepEntry.component
      const stepProps = stepEntry.getProps
        ? stepEntry.getProps({
            step,
            values,
            errors,
            touched,
            onChange,
            onBlur,
            onTeamNameError,
            setWidgetConfigErrors,
            editMode,
            onboardingDashboard,
            productId,
            setProductId,
            dispatch,
            setStep,
            stepConfig,
            onProductIdChange: props.onProductIdChange,
            handleDropdownChange: props.handleDropdownChange,
            selectedAppDAccount: props.selectedAppDAccount,
            setSelectedAppDAccount: props.setSelectedAppDAccount,
          })
        : props
      return <Step {...stepProps} />
    }
  }
}

export default StepComponent
